module.exports = __webpack_public_path__ + "static/media/qrsuccess.1ea24090.svg";